import type {SelectedAgent} from '@github-ui/agent-sessions-types/agent-identity'

import type {ComposerEventFields} from './composer-telemetry'
import type {ComposerAgentKind} from './constants'

function agentKind(agent: SelectedAgent | undefined | null): ComposerAgentKind {
  // `{}` is how the composer stores the default Copilot agent.
  if (!agent?.typeName) return 'default'
  return agent.typeName === 'customSubAgent' || agent.subAgentSlug ? 'custom' : 'top_level'
}

function publicAgentLogin(agent: SelectedAgent | undefined | null): string | undefined {
  return agentKind(agent) === 'top_level' ? agent?.login : undefined
}

export function agentTelemetryFields(
  from: SelectedAgent | undefined | null,
  to: SelectedAgent | undefined | null,
): ComposerEventFields {
  return {
    from_agent_kind: agentKind(from),
    to_agent_kind: agentKind(to),
    from_agent_login: publicAgentLogin(from),
    to_agent_login: publicAgentLogin(to),
  }
}

export function isSameAgent(a: SelectedAgent | undefined | null, b: SelectedAgent | undefined | null): boolean {
  if (agentKind(a) !== agentKind(b) || a?.subAgentSlug !== b?.subAgentSlug) return false
  // A preselected agent may carry only its login until it is enriched with an id.
  if (a?.login && b?.login) return a.login === b.login
  return a?.topLevelAgentId === b?.topLevelAgentId
}
